module.exports = __webpack_public_path__ + "img/register-tip.22411f2d.png";